(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fgs-soap-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-fgs-soap-picker]') || !event.target.value) return;
  const next = new URL(event.target.value, window.location.origin);
  if (next.origin === window.location.origin && next.pathname.includes('/products/')) window.location.assign(next.href);
});
  } catch(e) { console.error(e); }
})();

})();
